const signals = {}

export function sendSignal(name) {
  if (!signals[name]) return

  for (const signal of signals[name]) {
    signal()
  }

  delete signals[name]
}

export function waitForSignal(name) {
  if (!signals[name]) {
    signals[name] = []
  }

  return new Promise(resolve => {
    signals[name].push(resolve)
  })
}
